import { Center, Flex, Text } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import { SearchIcon } from '@halo/ui-chat-react';

interface DialogTriggerProps {
  isMiniNav: boolean;
  handleClick: () => void;
}

export function DialogTrigger({ isMiniNav, handleClick }: DialogTriggerProps) {
  const { t } = useTranslation();
  return (
    <Dialog.Trigger asChild>
      <Flex
        onClick={handleClick}
        bg="bg.muted"
        _hover={{
          bg: 'grey.64',
        }}
        transition="all 0.5s"
        borderRadius="lg"
        p={2}
        align="center"
        gap={1.5}
        justify="center"
        cursor="pointer"
        color="fg.subtle"
      >
        <Center flexShrink="0" fontSize="md">
          <SearchIcon />
        </Center>
        {!isMiniNav && (
          <Text fontSize="sm" fontWeight="medium">
            {t('filter.searchPlaceholder')}
          </Text>
        )}
      </Flex>
    </Dialog.Trigger>
  );
}
